export default __webpack_public_path__ + "static/media/policydoc.fd2ffba5.png";